"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _eventEmitter = _interopRequireDefault(require("../eventEmitter"));

var _transport = _interopRequireDefault(require("../../transport/transport.websocket"));

var _sync = require("./sync.constants");

var CONNECTING = 0,
    CLOSED = 3,
    CLOSING = 2,
    OPEN = 1,
    INITIAL = -1;
var OPEN_METHOD = ['read'],
    SEND_METHOD = ['create', 'update', 'destroy'];

var _default =
/*#__PURE__*/
function (_EventEmitter) {
  (0, _inherits2["default"])(_default, _EventEmitter);

  /**
   * @param {object} options
   * options.url - API URL
   * onOpen
   * onClose
   * onError - response protocol validation failed
   * onMessage
   */
  function _default() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, _default);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).call(this));
    _this.stream = null;
    _this.queue = [];
    _this.readyState = INITIAL;
    _this.options = options;
    _this.storage = options.storage;
    _this.url = options.url;
    _this.parsers = options.parsers;

    if (typeof options.protocol !== 'undefined') {
      _this.protocol = options.protocol;
    }

    _this.Transport = options.transport || _transport["default"];
    return (0, _possibleConstructorReturn2["default"])(_this, (0, _assertThisInitialized2["default"])(_this));
  }

  (0, _createClass2["default"])(_default, [{
    key: "query",
    value: function query() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var method = arguments.length > 1 ? arguments[1] : undefined;

      if (OPEN_METHOD.indexOf(method) >= 0) {
        // connect only
        return this.connect();
      } else if (SEND_METHOD.indexOf(method) >= 0) {
        // send data, connect if stream is closed
        if (!this.isOpen()) {
          this.connect();
        }

        return this.send(options);
      } else {
        return Promise.reject('WebSocket: sync method is required.');
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.stream && this.readyState === OPEN;
    }
  }, {
    key: "connect",
    value: function connect() {
      if (this.isOpen()) {
        return Promise.resolve(this.stream);
      } else {
        if (!this.url) {
          return Promise.reject('WebSocket: missed required "url" attribute.');
        }

        this.readyState = CONNECTING;
        this.stream = new this.Transport(this.url, this.options);
        this.stream.onopen = this._handleStreamOpen.bind(this);
        this.stream.onclose = this._handleStreamClose.bind(this);
        this.stream.onmessage = this._handleStreamMessage.bind(this);
        return Promise.resolve(this.stream);
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (this.isOpen() && this.stream && typeof this.stream.close === 'function') {
        this.readyState = CLOSING;
        this.stream.close();
      }

      return this;
    }
    /**
     * @param {object} data
     * @return {Promise}
     */

  }, {
    key: "send",
    value: function send() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.isOpen()) {
        var _data;

        try {
          _data = JSON.stringify(_data);
        } catch (e) {
          _data = '{}';
        }

        if (typeof this.stream.send === 'function') {
          this.stream.send(_data);
          return Promise.resolve();
        } else {
          return Promise.reject('WebSocket: send method is not defined. Check WebSocket transport API.');
        }
      } else {
        return this._addToQueue(data);
      }
    }
  }, {
    key: "get",
    value: function get() {
      return this.send.apply(this, arguments);
    }
  }, {
    key: "_handleStreamOpen",
    value: function _handleStreamOpen() {
      this.readyState = OPEN;

      if (typeof this.options.onOpen === 'function') {
        this.options.onOpen();
      }

      this._runQueue();
    }
  }, {
    key: "_handleStreamClose",
    value: function _handleStreamClose() {
      this.readyState = CLOSED;

      this._stopQueue();

      this._clearQueue();

      if (typeof this.options.onClose === 'function') {
        this.options.onClose();
      }
    }
  }, {
    key: "_handleStreamMessage",
    value: function _handleStreamMessage() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var response = event.data || {},
          packet = {};

      if (typeof this.protocol === 'function') {
        packet = this.protocol(response);
      } else {
        packet = {
          status: _sync.responseState.SUCCESS,
          data: response
        };
      }

      if (this.parsers && this.parsers[packet.status]) {
        packet = this.parsers[packet.status](response, this.options);
      } // response is invalid by protocol rules


      if (packet.status === _sync.responseState.ERROR) {
        if (typeof this.options.onError === 'function') {
          this.options.onError(packet);
        }

        if (this.storage && typeof this.storage.trigger === 'function') {
          this.storage.trigger('error:read', packet);
        }
      } else if (packet.status === _sync.responseState.SUCCESS) {
        if (this.storage && typeof this.storage.syncResolve === 'function') {
          this.storage.syncResolve(packet.data, this.options);
        }

        if (typeof this.options.onMessage === 'function') {
          this.options.onMessage(packet);
        }

        if (this.storage && typeof this.storage.trigger === 'function') {
          this.storage.trigger('success:read', packet);
        }
      }
    }
  }, {
    key: "_clearQueue",
    value: function _clearQueue() {
      this.queue.length = 0;
    }
  }, {
    key: "_stopQueue",
    value: function _stopQueue() {
      return clearInterval(this._queueInterval);
    }
  }, {
    key: "_runQueue",
    value: function _runQueue() {
      var _this2 = this;

      this._stopQueue();

      this._queueInterval = setInterval(function () {
        if (_this2.isOpen() && _this2.queue.length) {
          var item = _this2.queue.unshift();

          if (typeof item.cb === 'function') {
            item.cb();
          }

          if (typeof item.p === 'function') {
            item.p();
          }
        }
      }, 100);
    }
  }, {
    key: "_addToQueue",
    value: function _addToQueue(data) {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.queue.push({
          p: resolve,
          cb: function cb() {
            return _this3.send(data);
          }
        });
      });
    }
    /**
     * @return {object} singleton of this class
     */

  }], [{
    key: "getInstance",
    value: function getInstance() {
      var proto = Object.getPrototypeOf(this);

      if (!proto.singletonInstance) {
        var parent = this,
            Surrogate;

        Surrogate = function Surrogate() {
          var _parent$prototype$con;

          for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            rest[_key2] = arguments[_key2];
          }

          // для того что бы принимать динамическое к-во аргументов в конструктор
          return (_parent$prototype$con = parent.prototype.constructor).call.apply(_parent$prototype$con, [this].concat(rest));
        };

        Surrogate.prototype = parent.prototype;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        proto.singletonInstance = (0, _construct2["default"])(Surrogate, args);
      }

      return proto.singletonInstance;
    }
  }]);
  return _default;
}(_eventEmitter["default"]);

exports["default"] = _default;